module.exports = __webpack_public_path__ + "static/img/manual_zh_17.0584fb8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_17.png
// module id = GrbW
// module chunks = 4